module.exports = __webpack_public_path__ + "static/inspospotr-extraimg3@2x-min-d907aeef2a4c9b941aae3f0043c9aada.png";